<template>
    <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-primary">
        <div v-if="isAuth" class="d-flex w-100">
            <a class="navbar-brand" href="/index">
                <img class="d-none d-xl-block" src="/images/logo-white.png" alt="Ionaute" height="20" />
                <img class="d-xl-none" src="/images/logo-min-white.png" alt="Ionaute" height="20" />
            </a>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto" id="navbar-main">
                    <li :class="{'nav-item': true, 'active': isActiveRoute('index')}">
                        <a class="nav-link" :href="routeUrl('index')">{{ $t("dashboard") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('smart-vault.*')}" v-if="can('view smart-vault')">
                        <a class="nav-link" :href="routeUrl('smart-vault.index')">{{ $t("smartvault") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('orders.*')}" v-if="can('manage orders')">
                        <a class="nav-link" :href="routeUrl('orders.index')">{{ $t("orders") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('reports.*')}">
                        <a class="nav-link" :href="routeUrl('reports.index')">{{ $t("reports") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('analytics.*')}" v-if="can('view analytics')">
                        <a class="nav-link" :href="routeUrl('analytics.index')">{{ $t("analytics") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('brand-stories.*')}" v-if="can('manage brand stories')">
                        <a class="nav-link" :href="routeUrl('brand-stories.index')">{{ $t("brandStories") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('passports.*')}" v-if="can('view passports') || can('view all passports')">
                        <a class="nav-link" :href="routeUrl('passports.index')">{{ $t("passports") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('users.*')}" v-if="can('manage users')">
                        <a class="nav-link" :href="routeUrl('users.index')">{{ $t("users") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('companies.*')}" v-if="can('manage companies')">
                        <a class="nav-link" :href="routeUrl('companies.index')">{{ $t("companies") }}</a>
                    </li>

                    <li :class="{'nav-item': true, 'active': isActiveRoute('imports.*')}" v-if="can('manage orders imports')">
                        <a class="nav-link" :href="routeUrl('imports.index')">{{ $t("ordersImport") }}</a>
                    </li>
                </ul>
                <ul class="navbar-nav align-items-center">

                    <b-badge v-if="environment=='staging'" class="font-weight-normal p-2" variant="warning">Staging</b-badge>
                    <b-badge v-if="environment=='local'" class="font-weight-normal p-2" variant="danger">Dev</b-badge>

                    <common-full-screen-toggle class="hide-on-pwa d-none d-sm-block"></common-full-screen-toggle>

                    <li class="nav-item dropdown" v-if="can('manage report columns') || can('manage report templates') || can('manage problem categories') || can( 'manage product attributes' ) || can('manage roles') || can( 'manage templates')">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ $t("settings") }}
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a :class="{'dropdown-item': true, 'active': isActiveRoute('settings.product-attributes.*')}"
                                :href="routeUrl('settings.product-attributes.index')"
                                v-if="can('manage product attributes')"
                            >{{ $t('products_attributes') }}</a>

                            <a :class="{'dropdown-item': true, 'active': isActiveRoute('settings.columns.*')}"
                                :href="routeUrl('settings.columns.index')"
                                v-if="can('manage report columns')"
                            >{{ $t('report_columns') }}</a>

                            <a :class="{'dropdown-item': true, 'active': isActiveRoute('settings.templates.*')}"
                                :href="routeUrl('settings.templates.index')"
                                v-if="can('manage report templates')"
                            >{{ $t('report_template') }}</a>

                            <a :class="{'dropdown-item': true, 'active': isActiveRoute('settings.problems.*')}"
                                :href="routeUrl('settings.problems.index')"
                                v-if="can('manage problem categories')"
                            >{{ $t('problem_categories') }}</a>

                            <a :class="{'dropdown-item': true, 'active': isActiveRoute('settings.problem-department.*')}"
                                :href="routeUrl('settings.problem-department.index')"
                                v-if="can('manage problem categories')"
                            >{{ $t('problem_departments') }}</a>

                            <a :class="{'dropdown-item': true, 'active': isActiveRoute('settings.roles.*')}"
                                :href="routeUrl('settings.roles.index')"
                                v-if="can('manage roles')"
                            >{{ $t('roles_permissions') }}</a>
                        </div>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ currentUser.first_name + " " + currentUser.last_name }}</a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a v-if="can('manage users')" class="dropdown-item" :href="`/users/${currentUser.id}`">{{ $t("profile") }}</a>
                            <a class="dropdown-item" href="/logout">{{ $t("logout") }}</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div v-else>
            <a class="navbar-brand mx-auto" href="/">
                <img src="/images/logo-white.png" alt="Ionaute" height="20" />
            </a>
        </div>
    </nav>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    environment: {
      type: String,
      default: "production"
    },
    isAuth: {
      type: Boolean,
      default: false
    },
    currentUser: {
      type: Object,
      default: () => ({})
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    can(permissionName) {
      return this.permissions.some(
        permission => permission.name === permissionName
      );
    },
    routeUrl(routeName) {
      return route(routeName);
    },
    isActiveRoute(routeName) {
      return route().current(routeName);
    }
  }
};
</script>
